/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import {
  Button,
  CardHeader,
  Col,
  Form,
  Modal,
  Row,
  Spinner,
} from "react-bootstrap";
import { Card, CardBody, Label } from "reactstrap";
import ControlledRowTextField from "../../../components/ControlledRowTextField";
import ControlledSelect from "../../../components/ControlledSelect";
import ButtonComponent from "../../../components/ButtonComponent";
import {
  useCreateRestaurantHttpsMutation,
  useGetRestaurantCategoriesQuery,
  useGetRestaurantFlowTypesQuery,
  useGetRestaurantPropertiesQuery,
  useUploadRestaurantLogoFileExtntionHttpsMutation,
} from "../../../redux/services/restaurantServices";
import { toast } from "react-toastify";
import { RESTAURANT_ADD_FORM_NAME } from "../../../constants/constans";
import { useNavigate } from "react-router-dom";
import {
  faFloppyDisk,
  faMapMarkerAlt,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Map from "../../../components/LocationSelectorModal";
import { uploadImage } from "../../../components/imageUploadCompont";
import ControlledRowTextFieldDropDown from "../../../components/ControlledTextFieldDropDown";
import ControlledRowTextFieldAddress from "../../../components/ControlledRowTextFieldAddress";
import {
  capitalizeFirstLetter,
  categoryTagsOptionsFunction,
} from "../../../utility/Utility";
import ControlledRowTextFieldTime from "../../../components/ControlledRowTextFieldTime";
import BreadCrumbs from "../../../components/BreadCrumbs";
import { UpdateImageDetails } from "../../../components/MenuItemImageUpdate/MenuItemImageUpdate";
import IMGUploadComponent from "../../../components/IMGUploadComponent";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../redux/store";
import {
  openInitialSlectReastaurantModla,
  setSelectedRestaurantDetails,
} from "../../../redux/restaurantsSlice";
import { getImageUrl } from "../../../dummyData/FoodAttributes";
import LoadingMessage from "../../../components/LoadingMessage";

type Location = {
  latitude: any;
  longitude: any;
};

export type RestaurantFormData = {
  address: string;
  displayName: string;
  categoryTags: any;
  imageUrl: string | "";
  location: Location;
  ownerId: string;
  openingTime: any;
  closingTime: any;
  type: string;
  imageReference: string | "";
  latitude: any;
  longitude: any;
  restaurantProperties?: any;
  supportsDirectOrders?: boolean;
  canCollectMoney: boolean;
  flowTypes?: any;
  acceptCartReturns: boolean;
  deliverySettings: {
    isFreeDelivery: boolean;
    perItemDeliveryFee: number;
  };
};

export type LogoFileExtntionRequest = {
  fileExtention: string;
};
export type UpdateImageRequest = {
  restaurantId: string;
  menuItemId: string;
  newImages: Array<UpdateImageDetails>;
};

export type LogoFileExtntionResponse = {
  result: {
    imageReference: string;
    imageUploadUrl: string;
  };
};

const AddRestaurant = () => {
  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();

  const ownerId = localStorage.getItem("ownerID") || "";
  let selectedRestaurantId = localStorage.getItem("selectedRestaurantId") || "";

  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [imageError, setImageError] = useState("");
  const [isDirectOrders, setIsDirectOrders] = useState(false);
  const [isCanCollectMoney, setIsCanCollectMoney] = useState(false);
  const [isCanAcceptReturnRequests, setIsCanAcceptReturnRequests] =
    useState(false);
  const [uploadedImgDetails, setUploadedImgDetails] = useState<{
    imgSrc: string;
    formData: any;
    fileExtention: string;
  }>({
    imgSrc: "",
    formData: "",
    fileExtention: "",
  });
  const [selectedLocation, setSelectedLocation] = useState({
    lat: 28.7041,
    lng: 77.1025,
  });
  const [isFreeDelivery, setIsFreeDelivery] = useState(false);
  const [perItemDeliveryFee, setPerItemDeliveryFee] = useState(0);

  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<RestaurantFormData>({
    defaultValues: {
      address: "",
      displayName: "",
      categoryTags: [],
      imageUrl: "",
      location: { latitude: 0, longitude: 0 },
      ownerId: ownerId,
      openingTime: 0,
      closingTime: 0,
      type: "",
      imageReference: "",
      latitude: 0,
      longitude: 0,
      restaurantProperties: [],
      supportsDirectOrders: false,
      canCollectMoney: false,
      flowTypes: [],
      acceptCartReturns: false,
      deliverySettings: {
        isFreeDelivery: false,
        perItemDeliveryFee: 0,
      },
    },
  });

  const [createRestaurant] = useCreateRestaurantHttpsMutation();
  const [uploadLogoFileExtetion] =
    useUploadRestaurantLogoFileExtntionHttpsMutation();

  const createRestaurantMutation = async (requestData: RestaurantFormData) => {
    try {
      setIsLoading(true);
      const imageUrl = await uploadImage(uploadLogoFileExtetion, {
        fileExtention: uploadedImgDetails.fileExtention,
        formData: uploadedImgDetails.formData,
      });
      const restaurantResponse: any = await createRestaurant({
        ...requestData,
        imageReference: imageUrl,
      });
      if ("data" in restaurantResponse) {
        if (selectedRestaurantId === "") {
          localStorage.setItem(
            "selectedRestaurantId",
            restaurantResponse?.data?.id || ""
          );
          dispatch(openInitialSlectReastaurantModla(true));
          dispatch(setSelectedRestaurantDetails(restaurantResponse?.data));
        }
        toast.success("Restaurant Created");
        navigate("/profile");
      } else if (restaurantResponse?.error?.originalStatus === 409) {
        toast.error(
          "You cannot create two restaurants from same name in same place"
        );
      }
    } catch (error: any) {
      if (error.originalStatus === 409) {
        toast.error(
          "You cannot create two restaurants from same name in same place"
        );
      }
      toast.error("Failed to create restaurant. please check Enter Values");
    } finally {
      setIsLoading(false);
    }
  };

  const imageUploadCallback = (e: any) => {
    setUploadedImgDetails({
      ...uploadedImgDetails,
      imgSrc: e.imgSrc,
      formData: e.formData,
      fileExtention: e.fileExtention,
    });
    setImageError("");
  };

  //Category Tags

  const { data, error, isSuccess } = useGetRestaurantCategoriesQuery("");
  let categoryTagsOptions = [{ value: "", label: "" }];

  if (isSuccess) {
    categoryTagsOptions = categoryTagsOptionsFunction(data) || [
      { value: "", label: "" },
    ];
  }

  //Restaurant Properties

  const restaurantPropertiesFunction = (data: any) => {
    if (data && data.RestaurantPropertiesList) {
      const restauarntPropertiesArray = data.RestaurantPropertiesList;
      return restauarntPropertiesArray.map((item: any) => {
        return {
          value: capitalizeFirstLetter(item.displayName),
          label: (
            <div style={{ display: "flex", justifyContent: "left", gap: "2%" }}>
              <img
                src={getImageUrl(item.displayName)}
                alt={item.displayName}
                width="20px"
                height="20px"
              />
              {item.displayName}
            </div>
          ),
        };
      });
    } else {
      console.error("Invalid data structure:", data);
      return [];
    }
  };

  const {
    data: restaurantProperties,
    error: errorRestaurantProperties,
    isSuccess: isGetRestaurantPropertiesSuccess,
  } = useGetRestaurantPropertiesQuery("");
  let restaurantPropertiesOptions = [{ value: "", label: "" }];
  if (isSuccess) {
    restaurantPropertiesOptions = restaurantPropertiesFunction(
      restaurantProperties
    ) || [{ value: "", label: "" }];
  }

  const restaurantFlowTypesFunction = (data: any) => {
    if (data && data.FlowTypesList) {
      const restaurantFlowTypessArray = data.FlowTypesList;
      return restaurantFlowTypessArray.map((item: any) => {
        return {
          value: item.displayName,
          label: (
            <div style={{ display: "flex", justifyContent: "left", gap: "2%" }}>
              {item.displayName}
            </div>
          ),
        };
      });
    } else {
      console.error("Invalid data structure:", data);
      return [];
    }
  };

  const {
    data: restaurantFlowTypes,
    error: errorRestaurantFlowTypes,
    isSuccess: isGetRestaurantFlowTypesSuccess,
  } = useGetRestaurantFlowTypesQuery("");
  let restaurantFlowTypesOptions = [{ value: "", label: "" }];
  if (isSuccess) {
    restaurantFlowTypesOptions = restaurantFlowTypesFunction(
      restaurantFlowTypes
    ) || [{ value: "", label: "" }];
  }

  const onSubmit = async (data: RestaurantFormData) => {
    if (!uploadedImgDetails.formData) {
      setImageError("Please upload an image.");
      return;
    }
    const latitude = parseFloat(data.latitude);
    const longitude = parseFloat(data.longitude);
    const categroryTagList = data?.categoryTags.map((item: any) => item.value);
    const restaurantProperties = data?.restaurantProperties.map(
      (item: any) => item.value
    );
    const flowTypes = data?.flowTypes.map((item: any) => item.value);
    const requestData = {
      ...data,
      openingTime: data.openingTime || "08:30",
      closingTime: data.closingTime || "20:30",
      location: {
        latitude: latitude,
        longitude: longitude,
      },
      categoryTags: categroryTagList,
      restaurantProperties: restaurantProperties,
      supportsDirectOrders: data.supportsDirectOrders,
      canCollectMoney: data.canCollectMoney,
      flowTypes: flowTypes,
      acceptCartReturns: data.acceptCartReturns,
      deliverySettings: {
        isFreeDelivery: data.deliverySettings.isFreeDelivery,
        perItemDeliveryFee: parseFloat(data.deliverySettings.perItemDeliveryFee.toLocaleString()) || 0,
      },
    };
    createRestaurantMutation(requestData);
  };

  //Form Submit
  const handleLocationModalClose = () => {
    setShowModal(false);
  };

  const handleLocationSave = (
    latitude: number,
    longitude: number,
    address: string
  ) => {
    setSelectedLocation({ lat: latitude, lng: longitude });
    setValue("latitude", latitude);
    setValue("longitude", longitude);
    setValue("address", address);
  };

  return (
    <>
      <BreadCrumbs hasSubMenus={false} />
      <br />
      <Card>
        <CardHeader style={{ backgroundColor: "#fff" }}>
          <h4>{RESTAURANT_ADD_FORM_NAME}</h4>
        </CardHeader>
        <CardBody>
          <Form
            className="auth-login-form mt-2"
            onSubmit={handleSubmit(onSubmit)}
          >
            {!isSuccess ? (
              <div className="bg-white">
                <LoadingMessage />
              </div>
            ) : (
              <>
                <IMGUploadComponent
                  imageUrl={uploadedImgDetails.imgSrc}
                  onUpload={imageUploadCallback}
                />
                {imageError && (
                  <p className="text-danger ml-4 text-align-right">
                    {imageError}
                  </p>
                )}
                <hr />
                <ControlledRowTextField
                  label={"Name"}
                  inputName={"displayName"}
                  inputType={"text"}
                  placeholder={"Enter Restaurant Name"}
                  isRequired={true}
                  control={control}
                />
                <hr />
                <ControlledRowTextFieldAddress
                  label={"Address"}
                  inputName={"address"}
                  inputType={"text"}
                  placeholder={"Select location of your restaurant"}
                  isRequired={true}
                  control={control}
                  setShowModal={setShowModal}
                  rules={{ required: "Please enter an address" }}
                  errors={errors}
                />
                <hr />
                <Row style={{ display: "none" }}>
                  <Col lg="5">
                    <ControlledRowTextField
                      label={"Latitude"}
                      inputName={"latitude"}
                      inputType={"number"}
                      placeholder={"Enter Latitude"}
                      isRequired={true}
                      control={control}
                    />
                  </Col>
                  <Col lg="5">
                    <ControlledRowTextField
                      label={"Longitude"}
                      inputName={"longitude"}
                      inputType={"number"}
                      placeholder={"Enter Longitude"}
                      isRequired={true}
                      control={control}
                    />
                  </Col>
                  <Col lg="2">
                    <Button
                      variant="info"
                      type="button"
                      onClick={() => setShowModal(true)}
                    >
                      <FontAwesomeIcon icon={faMapMarkerAlt} />
                    </Button>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Label>Restaurant available time</Label>
                  </Col>
                  <Col>
                    <ControlledRowTextFieldTime
                      label={"Opening Time"}
                      inputName={"openingTime"}
                      control={control}
                      isRequired={true}
                      inputType={"time"}
                      defaultValue={"08:30"} // default opening time
                    />
                  </Col>
                  <Col>
                    <ControlledRowTextFieldTime
                      label={"Closing Time"}
                      inputName={"closingTime"}
                      control={control}
                      isRequired={true}
                      inputType={"time"}
                      defaultValue={"20:30"} // default closing time
                    />
                  </Col>
                </Row>
                <hr />
                <ControlledSelect
                  label={"Categories"}
                  inputName={"categoryTags"}
                  control={control}
                  isMulti={true}
                  optionsList={categoryTagsOptions}
                  isRequired={true}
                />
                <hr />
                <ControlledSelect
                  label={"Properties"}
                  inputName={"restaurantProperties"}
                  control={control}
                  isMulti={true}
                  optionsList={restaurantPropertiesOptions}
                  isRequired={true}
                />
                <hr />
                <ControlledSelect
                  label={"Flow Types"}
                  inputName={"flowTypes"}
                  control={control}
                  isMulti={true}
                  optionsList={restaurantFlowTypesOptions}
                  isRequired={true}
                />
                <hr />
                <ControlledRowTextFieldDropDown
                  label={"Type"}
                  inputName={"type"}
                  inputType={"dropdown"}
                  placeholder={"Select Restaurant Type"}
                  isRequired={true}
                  control={control}
                  rules={{ required: "Please select a restaurant type" }} // Add validation rule
                  errors={errors} // Pass down errors from useForm
                />
                <hr />
                <Row>
                  <Col lg="4">
                    <Label
                      className="form-check-label"
                      htmlFor="supportsDirectOrders"
                    >
                      Can Direct Pickup
                    </Label>
                  </Col>
                  <Col lg="8">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="supportsDirectOrders"
                      checked={isDirectOrders}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setIsDirectOrders(event.target.checked);
                        setValue("supportsDirectOrders", event.target.checked);
                      }}
                    />
                  </Col>
                </Row>
                <hr />
                <Row>
                  <Col lg="4">
                    <Label
                      className="form-check-label"
                      htmlFor="canCollectMoney"
                    >
                      Collect Money
                    </Label>
                  </Col>
                  <Col lg="8">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="canCollectMoney"
                      checked={isCanCollectMoney}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setIsCanCollectMoney(event.target.checked);
                        setValue("canCollectMoney", event.target.checked);
                      }}
                    />
                  </Col>
                </Row>
                <hr />
                <Row>
                  <Col lg="4">
                    <Label
                      className="form-check-label"
                      htmlFor="canCollectMoney"
                    >
                      Accecpt Cart Return Requests
                    </Label>
                  </Col>
                  <Col lg="8">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="acceptCartReturns"
                      checked={isCanAcceptReturnRequests}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setIsCanAcceptReturnRequests(event.target.checked);
                        setValue("acceptCartReturns", event.target.checked);
                      }}
                    />
                  </Col>
                </Row>
                <hr />
                <Row>
                  <Col lg="4">
                    <Label
                      className="form-check-label"
                      htmlFor="isFreeDelivery"
                    >
                      Free Delivery
                    </Label>
                  </Col>
                  <Col lg="8">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="isFreeDelivery"
                      checked={isFreeDelivery}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setIsFreeDelivery(event.target.checked);
                        setValue(
                          "deliverySettings.isFreeDelivery",
                          event.target.checked
                        );
                      }}
                    />
                  </Col>
                </Row>
                <hr />
             
                  <ControlledRowTextField
                    label={"Per Item Delivery Fee"}
                    inputName={"deliverySettings.perItemDeliveryFee"}
                    inputType={"number"}
                    placeholder={"Enter delivery fee"}
                    control={control}
                    rules={{
                      required:
                        "Delivery fee is required when free delivery is disabled",
                      min: {
                        value: 0,
                        message: "Delivery fee cannot be negative",
                      },
                    }}
                    errors={errors}
                  />
              
                <br />
                <div style={{ textAlign: "end" }}>
                  {isLoading ? (
                    <ButtonComponent
                      type={"submit"}
                      icon={
                        <FontAwesomeIcon
                          icon={faSpinner}
                          spin
                          title="Saving..."
                        />
                      }
                      titel="Saving..."
                      isDisabled={true}
                    />
                  ) : (
                    <ButtonComponent
                      type="submit"
                      icon={<FontAwesomeIcon icon={faFloppyDisk} />}
                      titel="Save"
                      isDisabled={isLoading}
                    />
                  )}
                </div>
              </>
            )}

            <br />
            <Modal
              show={showModal}
              onHide={() => setShowModal(false)}
              centered
              size="lg"
              backdrop="static"
              keyboard={false}
            >
              <Modal.Header closeButton>
                <Modal.Title>Select your location</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Map onSaveLocation={handleLocationSave} />
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => handleLocationModalClose()}
                >
                  Save
                </Button>
              </Modal.Footer>
            </Modal>
          </Form>
        </CardBody>
      </Card>
    </>
  );
};

export default AddRestaurant;
